import Layout from '@/layout'
export default {
    meta: {
        title: '公司',
        icon: 'b-qy'
    },
    path: "/BxCom",
    component: Layout,
    children: [{
        path: '/BxCom/index',
        name: 'BxCom',
        component: () => import('@/views/BxCom/index'),
        meta: {
            title: '保险公司',
            auth: [],
            img: "tis"
        }
    },
    {
        path: '/BxCom/add',
        name: 'BxComAdd',
        hide: true,
        component: () => import('@/views/BxCom/add'),
        meta: {
            // title: 'TIS机构管理',
            // confirm: "新增TIS机构",
            view: "查看保险公司",
            // tisConfirm: "新增TIS机构",
            // confirm2: "新增TIS机构",
            add: "新增保险公司",
            edit: '修改保险公司',
            auth: [],
            img: "idi",
            auth: [],
            img: "yhgl"
        },
        props: route => {
            return route.query;
        }
    }]
}

